export default __webpack_public_path__ + "static/media/decrease.fa8e3280.svg";